<template lang="pug">
  .col-md-12
    span.error-handling {{errorMsg}}
    .list-group
      .list-group-item Orders
        span.badge {{orders | number}}
      .list-group-item Codes
        span.badge {{codes | number}}
</template>

<script>
import Core from '@/service/apis/Core'
import { numberFilter } from '@/filters/filters'

export default {
  props: ['filter'],
  data: () => ({
    errorMsg: null,
    codes: null,
    orders: null
  }),
  methods: {
    fetchData() {
      Core.serializationStatistics({ startDate: this.filter.startDate, endDate: this.filter.endDate })
        .then((resp) => {
          this.codes = resp.data.codes
          this.orders = resp.data.orders
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    filter: {
      handler() {
        this.fetchData()
      },
      deep: true
    },
  },
  filters: {
    number: numberFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/components/CodesProduced.vue